import BindServiceCorp from "./BindServiceCorp";
export default BindServiceCorp;
